import React, { useState, useMemo } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { countryCodes } from '../data/countryCodes';
import { useAuth } from '../context/AuthContext';
import CountryCodePicker from './CountryCodePicker';
const API_URL = process.env.REACT_APP_API_URL;
const RegisterForm = ({ onSuccess, idPrefix = '' }) => {
  const { t, i18n } = useTranslation();
  const { login } = useAuth();
  
  const [formData, setFormData] = useState({ 
      firstName: '', lastName: '', countryCode: '+90', 
      phone: '', email: '', password: '', customerType: 'bireysel' 
  });
  const [agreed, setAgreed] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const handleChange = (e) => { 
      setFormData({ ...formData, [e.target.name]: e.target.value }); 
  };

  const handleCountryCodeChange = (code) => { setFormData({ ...formData, countryCode: code }); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!agreed) { setError(t('must_agree_terms')); return; }
    setError(''); setMessage(''); setIsLoading(true);
    
    try {
      // Adım 1: Kullanıcıyı kaydet
      const registerResponse = await fetch(`${API_URL}/api/auth/register`, { 
          method: 'POST', 
          headers: { 'Content-Type': 'application/json' }, 
          body: JSON.stringify(formData) 
      });
      const registerData = await registerResponse.json();
      if (!registerResponse.ok) { 
          throw new Error(t(registerData.messageKey) || t('registration_failed')); 
      }
      
      setMessage(t('registration_success_logging_in'));

      // Adım 2: Giriş yap
      const loginResponse = await fetch(`${API_URL}/api/auth/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: formData.email, password: formData.password })
      });
      const loginData = await loginResponse.json();
      if (!loginResponse.ok) { throw new Error(t('auto_login_failed')); }
      
      // DÜZELTME: login() fonksiyonu artık burada, merkezi olarak çağrılıyor.
      login(loginData.user, loginData.token);
      
      if (onSuccess) onSuccess(); // Üst bileşene haber ver (artık veri göndermeye gerek yok)

    } catch (err) {
      setError(err.message);
      setTimeout(() => setError(''), 5000);
    } finally {
      setIsLoading(false);
    }
  };

  const sortedCountryOptions = useMemo(() => {
    return [...countryCodes].sort((a, b) => 
      t(a.nameKey).localeCompare(t(b.nameKey), i18n.language)
    );
  }, [i18n.language, t]);

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
     
      <div className="form-row-auth">
        <div className="form-group-auth floating-label half-width">
          <input id={`${idPrefix}firstName`} name="firstName" type="text" onChange={handleChange} required placeholder=" " />
          <label htmlFor={`${idPrefix}firstName`}>{t('first_name')}</label>
        </div>
        <div className="form-group-auth floating-label half-width">
          <input id={`${idPrefix}lastName`} name="lastName" type="text" onChange={handleChange} required placeholder=" " />
          <label htmlFor={`${idPrefix}lastName`}>{t('last_name')}</label>
        </div>
      </div>
      <div className="form-row-auth">
          <div className="form-group-auth phone-code">
          
            <CountryCodePicker
            selectedCode={formData.countryCode}
            onCodeChange={handleCountryCodeChange}
          />
          </div>
        <div className="form-group-auth floating-label phone-number">
          <input id={`${idPrefix}phone`} name="phone" type="tel" onChange={handleChange} placeholder=" " />
          <label htmlFor={`${idPrefix}phone`}>{t('phone')}</label>
        </div>
      </div>
      <div className="form-group-auth floating-label">
        <input id={`${idPrefix}register-email`} name="email" type="email" onChange={handleChange} required placeholder=" " />
        <label htmlFor={`${idPrefix}register-email`}>{t('email_address')}</label>
      </div>
       <div className="form-group-auth floating-label password-group">
        <input 
          id={`${idPrefix}register-password`} 
          name="password" 
          type={isPasswordVisible ? 'text' : 'password'} 
          onChange={handleChange} 
          required 
          minLength="8"
          placeholder=" " 
        />
        <label htmlFor={`${idPrefix}register-password`}>{t('password')}</label>
        <button 
            type="button" 
            className="toggle-password" 
            onClick={() => setIsPasswordVisible(!isPasswordVisible)}
            title={isPasswordVisible ? t('hide_password') : t('show_password')}
        >
            <i className={`fas ${isPasswordVisible ? 'fa-eye-slash' : 'fa-eye'}`}></i>
        </button>
      </div>
      {error && <p className="auth-error">{error}</p>}
      {message && <p className="auth-success">{message}</p>}
      <label className="auth-checkbox agreement">
        <input type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} /> 
         <span>
            {/* DÜZELTME: Yeni anahtar ve link kullanılıyor */}
            <Trans i18nKey="agree_membership_terms_with_link">
              <Link to="/membership-terms" target="_blank" className="text-link" />
            </Trans>
          </span>
      </label>
      <button type="submit" className="auth-submit-btn" disabled={isLoading || !agreed}>
        {isLoading ? t('registering') : t('register_button')}
      </button>
    </form>
  );
};

export default RegisterForm;